import React from 'react';
import { Table } from 'design-react-kit';
import './table_lp.less';

const TableLP = ({ content }) => {
  return (
    <div className="table-prestazioni-libera-professione-wrapper">
      <Table className="table-prestazioni-libera-professione" size="sm">
        <tbody>
          {content.libera_professione.map((lp, lp_index) => (
            <tr key={lp_index}>
              <td>
                {lp.prestazione} {lp.struttura && <span className="struttura">({lp.struttura})</span>}
              </td>
              <td className="price text-right">
                {Number(lp.costo).toLocaleString('it-IT', {
                  style: 'currency',
                  currency: 'EUR',
                })}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
export default TableLP;
